import * as React from "react";
import { history } from "../../../history";
import InputMask from "react-input-mask";
import { NavigationStep } from "../../types";
import { PatientFormParams } from "../../patient/types";
import { User } from "../../session/types";
import { Organization } from "../../organizations/types";

interface OwnProps {
  user: User | null;
  quickContact: (patient: PatientFormParams, step: NavigationStep) => void;
  isEmbeddedSession: boolean;
  organization: Organization | null;
}

interface OwnState {
  submitSmsDisabled: boolean;
  submitEmailDisabled: boolean;
  phonenumber: string;
  firstname: string;
  lastname: string;
  email: string;
}

type Props = OwnProps;

class QuickContact extends React.PureComponent<Props, OwnState> {
  constructor(props: Props) {
    super(props);
    this.state = this.resetState();

    this.sendMessage = this.sendMessage.bind(this);
    this.startVideoChatSms = this.startVideoChatSms.bind(this);
    this.startVideoChatEmail = this.startVideoChatEmail.bind(this);
  }

  private resetState = () => {
    return {
      submitSmsDisabled: true,
      submitEmailDisabled: true,
      phonenumber: "",
      firstname: "",
      lastname: "",
      email: ""
    };
  };

  private validate = () => {
    this.setState({
      submitSmsDisabled: this.state.phonenumber.replace(/[^0-9]/g, "").length === 10 ? false : true,
      submitEmailDisabled: this.state.email ? false : true
    });
    return;
  };

  private phoneInputChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState(
      {
        phonenumber: e.target.value
      },
      () => this.validate()
    );
  };

  private emailInputChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState(
      {
        email: e.target.value
      },
      () => this.validate()
    );
  };

  private firstnameChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      firstname: e.target.value
    });
  };

  private lastnameChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      lastname: e.target.value
    });
  };

  private sendMessage = () => {
    this.props.quickContact(this.generatePatient(), NavigationStep.MessagePatient);
  };

  private startVideoChatSms = () => {
    this.props.quickContact(this.generatePatient(), NavigationStep.VideoChatSms);
  };

  private startVideoChatEmail = () => {
    this.props.quickContact(this.generatePatient(), NavigationStep.VideoChatEmail);
  };

  private generatePatient = () => {
    return {
      givenName: this.state.firstname ? this.state.firstname : "Unknown",
      familyName: this.state.lastname ? this.state.lastname : "Unknown",
      phone: this.state.phonenumber.replace(/[^0-9]/g, ""),
      email: this.state.email,
      isActive: true,
      mrn: null,
      accountId: null
    };
  };

  render() {
    const { firstname, lastname } = this.state;
    const { user, organization } = this.props;

    return (
      <div className="quickContactContainer">
        {this.props.isEmbeddedSession && (
          <div className="back-button" role="button" onClick={() => history.goBack()}>
            <i className="fas fa-arrow-alt-circle-left mr-10" />
          </div>
        )}

        <h1>Contact Patient</h1>

        <label htmlFor="firstname">First Name</label>
        <input
          id="firstname"
          className="form-control"
          defaultValue={firstname}
          onChange={this.firstnameChanged}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
        ></input>

        <label htmlFor="lastname">Last Name</label>
        <input
          id="lastname"
          className="form-control"
          defaultValue={lastname}
          onChange={this.lastnameChanged}
        ></input>

        <label htmlFor="phone">Phone Number</label>
        <InputMask
          className="form-control text-center"
          onChange={this.phoneInputChanged}
          mask="(999) 999-9999"
          type="tel"
        />

        {organization?.enableSendingEmail && (
          <>
            <label htmlFor="email">Email Address</label>
            <input
              className="form-control text-center"
              onChange={this.emailInputChanged}
              type="email"
            ></input>
          </>
        )}

        <div className="flex-between mt-20">
          <button
            className="mt-10"
            onClick={this.sendMessage}
            disabled={this.state.submitSmsDisabled}
          >
            <i className="fal fa-comment-alt-lines mr-5"></i> SMS Message
          </button>

          {user && user.featureFlags?.enableVideo && (
            <button
              className="mt-10 video-invite"
              onClick={this.startVideoChatSms}
              disabled={this.state.submitSmsDisabled}
            >
              <i className="fas fa-video mr-5"></i> Text Video Visit Invite
            </button>
          )}
        </div>
        <div className="flex-end mt-10">
          {organization?.enableSendingEmail && user && user.featureFlags?.enableVideo && (
            <button
              className="video-invite"
              onClick={this.startVideoChatEmail}
              disabled={this.state.submitEmailDisabled}
            >
              <i className="fas fa-video mr-5"></i> Email Video Visit Invite
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default QuickContact;
